import { Box, Flex, Text, CircularProgress, CircularProgressLabel, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, SimpleGrid, Grid, Checkbox, } from "@chakra-ui/react";
import { WarningIcon } from "@chakra-ui/icons";
import { MyDiv } from "./resignationNotification.style";
import { useFetch } from "../../../../hooks/useFetch";
import { CustomToast } from "../../../../components";
import { useEffect, useState } from "react";

interface NoticeSummary {
    remainingDays: number;
    completedSteps: number;
    totalSteps: number;
    resignation_Id: number
}

const ResignationNotification = () => {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [noticePeriodData, setNoticePeriodData] = useState<NoticeSummary | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [tasks, setTasks] = useState<any[]>([]);
    const [loadingTasks, setLoadingTasks] = useState(false);

    const loadResignationNotification = async () => {
        const response = await fetchApi("Resignation/notice-summary", "GET");
        if (response && response.resignation_Id > 0) {
            setNoticePeriodData(response);
        } else {
            setNoticePeriodData(null);
        }
    };

    const handleCardClick = async () => {
        if (!noticePeriodData?.resignation_Id) return;
        setIsOpen(true);
        setLoadingTasks(true);

        const response = await fetchApi("Resignation/TasksByResignation", "GET", "", `resignationId=${noticePeriodData?.resignation_Id}`);
        if (response) {
            setTasks(response);
        }

        setLoadingTasks(false);
    };

    useEffect(() => {
        loadResignationNotification();
    }, []);

    if (!noticePeriodData) return null;

    const { completedSteps, totalSteps, remainingDays } = noticePeriodData;

    const progressValue =
        totalSteps > 0 ? (completedSteps / totalSteps) * 100 : 0;

    const getProgressText = () => {
        if (completedSteps === 0) return "No processes completed yet";
        if (completedSteps === totalSteps) return "All exit processes completed";
        return `${completedSteps} steps completed out of ${totalSteps}`;
    };

    if (!noticePeriodData || !noticePeriodData.resignation_Id) {
        return null;
    }

    return (
        <>
            <MyDiv>
                <Box className="notice-card" cursor="pointer" onClick={handleCardClick} >
                    <Flex justify="space-between" align="center">
                        <Flex gap={5} align="flex-start">
                            <WarningIcon className="icon" boxSize={6} />
                            <Box>
                                <Text className="font-poppins text_medium text_md" mb={1}>Notice Period In Progress</Text>
                                <Text className="description font-poppins text_sm">You have{" "}<Text as="span" className="highlight">{remainingDays} days remaining</Text>{" "}to complete your notice period.</Text>
                            </Box>
                        </Flex>

                        <Box textAlign="center">
                            <CircularProgress value={progressValue} size="64px"
                                thickness="10px"
                                color={progressValue === 100 ? "green.500" : "red.500"}
                                trackColor="#e9e8e8ff"
                                ml={12}
                            >
                                <CircularProgressLabel>
                                    {completedSteps}/{totalSteps}
                                </CircularProgressLabel>
                            </CircularProgress>

                            <Text className="status-text font-poppins text_sm text_medium">
                                {getProgressText()}
                            </Text>
                        </Box>
                    </Flex>
                </Box>
            </MyDiv>

            {/* ================= MODAL ================= */}
            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} size="lg">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Tasks Checklist</ModalHeader>
                    <ModalCloseButton />

                    <ModalBody>

                        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                            {tasks.map((task: any) => (
                                <Grid key={task.id} border="1px solid #e2e8f0" p={3} borderRadius="md">
                                    <Checkbox isChecked={task.status === 1} isDisabled > {task.taskType}</Checkbox>
                                    <Text fontSize="xs" color="gray.600" mt={1}>Assigned To: <b>{task.assignedToName}</b></Text>
                                    {task.status === 1 && (<Text fontSize="xs" color="green.600" mt={1}>Completed by {task.completedByName} on{" "}{new Date(task.completedOn).toLocaleString("en-IN")}</Text>)}
                                    {task.status === 0 && (<Text fontSize="xs" color="red.500" mt={1}>Pending</Text>)}
                                </Grid>
                            ))}
                        </SimpleGrid>;
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};

export default ResignationNotification;
